export const API_ENDPOINT = {
  Login: {
    api: "/auth/v1/login",
    method: "POST",
  },
  Logout: {
    api: "/auth/v1/logout",
    method: "POST",
  },
  Otp: {
    api: "/auth/v1/verifyOTP",
    method: "POST",
  },
  CountryList: {
    api: "/auth/v1/getCountryList"
  },
  Profile: {
    api: "/company/v1/employee-profile",
  },
  Reservation: {
    api: "/booking/v2/reservations",
    getAPI: "/trip-api/v3/b2b-trips",
    cancelReasonApi: "/booking/v1/cancel-reasons",
    bufferTimeApi: "/booking/v1/pre-reservation-time",
    companyCity: "/company/v2/company-cities",
    companyService: "/company/v2/company-services",
    extensionRequestApi: "/trip-api/v3/extension-request",
  },
  Employee: {
    api: "/company/v1/employee",
    patchApi: "/company/v1/employee",
  },
  Car: {
    api: "/company/v2/car-types",
    facilities:"/company/v1/config-cars",
  },
  DutyType: {
    api: "/company/v1/duty-type",
  },
  ServiceCity: {
    api: "/trip-api/v1/service-cities",
    City: "/company/v1/city",
    serviceRegion: "/trip-api/v1/service-regions",
    subVendorRegion: "/admin-api/v1/subvendor-serviceable-regions",
  },

  Company: {
    api: "/company/v1/on-boarding",
    onboardingDetails: "/company/v1/details",
  },

  RateCard: {
    api: "/company/v2/rate-cards",
    calculationApi: "/booking/v2/rate-estimates",
    vendorDuty: '/admin-api/v3/vendor/active-services',
  },

  operations: {
    cancelTrip: "/trip-api/v3/cancel-trips/",
  },

  GoogleMap: {
    autocompleteApi: "/trip-api/v1/auto-complete",
    nearbysearch: "/trip-api/v1/nearbySearch-api",
    placeApi: "/trip-api/v1/place-api",
    directionApi: "/trip-api/v1/direction-api",
    geocodeApi: "/geocode/json",
  },

  Billing: {
    billing: "/booking/v1/performa-invoices",
    billingApproval: "/booking/v1/performa-invoice-verifications",
  },

  Dashboard:{
    rideDetailsApi: "/booking/v1/dashboard-ride-details",
  },
  userDeletion: {
    api: "/customer-api/v1/send-user-details"
  }
};
